import { forwardRef } from 'react'
import { IconProps } from '@/types/icon'

export const TokenDefaultIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg width="16" height="16" viewBox="0 0 214 214" ref={forwardedRef} {...props} color={color}>
        <rect width="214" height="214" fill="#182020" />
        <path
          d="M152.5 24C152.5 24 153.962 37.6473 159.657 43.3426C165.353 49.0379 179 50.5 179 50.5C179 50.5 165.353 51.9621 159.657 57.6574C153.962 63.3527 152.5 77 152.5 77C152.5 77 151.038 63.3527 145.343 57.6574C139.647 51.9621 126 50.5 126 50.5C126 50.5 139.647 49.0379 145.343 43.3426C151.038 37.6473 152.5 24 152.5 24Z"
          fill="#9EFCFD"
        />
        <path
          d="M40.5 113C40.5 113 41.2449 119.952 44.1462 122.854C47.0476 125.755 54 126.5 54 126.5C54 126.5 47.0476 127.245 44.1462 130.146C41.2449 133.048 40.5 140 40.5 140C40.5 140 39.7551 133.048 36.8538 130.146C33.9524 127.245 27 126.5 27 126.5C27 126.5 33.9524 125.755 36.8538 122.854C39.7551 119.952 40.5 113 40.5 113Z"
          fill="#9EFCFD"
        />
        <circle
          cx="107.006"
          cy="107.006"
          r="43.6734"
          transform="rotate(135 107.006 107.006)"
          fill="#9EFCFD"
          stroke="#9EFCFD"
          stroke-width="6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M119.597 93.5351C154.593 125.572 177.466 157.549 170.684 164.958L170.521 165.126C163.374 172.053 129.762 152.149 95.0382 120.362C60.042 88.3252 37.1691 56.349 43.95 48.9403C50.7316 41.5322 84.5999 61.4978 119.597 93.5351ZM148.52 148.837C135.591 141.215 118.934 128.68 101.791 112.986C84.6467 97.2918 70.6926 81.8044 61.961 69.5975C59.2865 65.8584 57.2192 62.5879 55.7168 59.8379C55.6713 59.7547 55.7565 59.6616 55.8434 59.6996C58.715 60.9539 62.1546 62.7257 66.1146 65.0602C79.0435 72.682 95.7004 85.2171 112.844 100.911C129.988 116.605 143.942 132.093 152.674 144.3C155.348 148.038 157.416 151.308 158.918 154.058C158.963 154.141 158.878 154.234 158.791 154.196C155.92 152.942 152.48 151.171 148.52 148.837Z"
          fill="#9EFCFD"
          stroke="#182020"
          stroke-width="3"
        />
        <mask id="path-5-inside-1_3055_3961" fill="white">
          <path d="M142.755 137.013C150.427 127.873 154.306 116.142 153.596 104.23C152.887 92.318 147.641 81.1305 138.938 72.9663C130.235 64.8021 118.736 60.2814 106.803 60.3332C94.8703 60.385 83.4105 65.0053 74.7788 73.2447L107.006 107.006L142.755 137.013Z" />
        </mask>
        <path
          d="M142.755 137.013C150.427 127.873 154.306 116.142 153.596 104.23C152.887 92.318 147.641 81.1305 138.938 72.9663C130.235 64.8021 118.736 60.2814 106.803 60.3332C94.8703 60.385 83.4105 65.0053 74.7788 73.2447L107.006 107.006L142.755 137.013Z"
          fill="#9EFCFD"
          stroke="#9EFCFD"
          stroke-width="12"
          mask="url(#path-5-inside-1_3055_3961)"
        />
      </svg>
    )
  },
)

TokenDefaultIcon.displayName = 'TokenDefaultIcon'
